import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var s = 0;

var t = /*#__PURE__*/function () {
  function t() {
    var _t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, t);

    this.uid = s++, _t ? (this._wkt = void 0 !== _t.wkt ? _t.wkt : null, this._wkid = void 0 !== _t.wkid ? _t.wkid : -1, this._isInverse = void 0 !== _t.isInverse && !0 === _t.isInverse) : (this._wkt = null, this._wkid = -1, this._isInverse = !1);
  }

  _createClass(t, [{
    key: "wkt",
    get: function get() {
      return this._wkt;
    },
    set: function set(_t2) {
      this._wkt = _t2, this.uid = s++;
    }
  }, {
    key: "wkid",
    get: function get() {
      return this._wkid;
    },
    set: function set(_t3) {
      this._wkid = _t3, this.uid = s++;
    }
  }, {
    key: "isInverse",
    get: function get() {
      return this._isInverse;
    },
    set: function set(_t4) {
      this._isInverse = _t4, this.uid = s++;
    }
  }, {
    key: "getInverse",
    value: function getInverse() {
      var s = new t();
      return s._wkt = this.wkt, s._wkid = this._wkid, s._isInverse = !this.isInverse, s;
    }
  }], [{
    key: "fromGE",
    value: function fromGE(s) {
      var i = new t();
      return i._wkt = s.wkt, i._wkid = s.wkid, i._isInverse = s.isInverse, i;
    }
  }]);

  return t;
}();

export { t as default };